import React, { useEffect, useMemo, useRef, useState } from 'react';
import './../ApiDocumentation.scss';
import packageJson from '../../../../package.json';
import { useLocation } from 'react-router-dom';

const WebhooksApi: React.FC = () => {

    let apiMaticObject: any = null;
    const version = packageJson.version;
    const envName = process.env.REACT_APP_ENVNAME;   

    const location = useLocation();  
    const apiEndpoint = "api-endpoints"
    const [newLocation, setNewLocation] = useState<any>(location.hash);
    const [isLoading, setLoading] = useState<any>(true);
    const [apiMaticWidgetTopPosition, setApiMaticWidgetTopPosition] = useState<number>(0);

    const mounted = useRef(false);
    useEffect(() => {
           mounted.current = true;
   
           return () => {
               mounted.current = false;
           };
       }, []);
       
    useEffect(() => {
      const apiMaticWidget = document.getElementById("apimatic-widget");

      if (apiMaticWidget) {
        const apiMaticWidgetTop =
          document.getElementById("apimatic-widget")?.getBoundingClientRect()
            .top || 0;

        // Considering margin top for heading-markdown is 20 px and adding 2 px extra spacings
        setApiMaticWidgetTopPosition(apiMaticWidgetTop + 22);
      }
    }, []);

    const naviagateToElement = (locHash: string) => {
      const removeHashCharacter = (str) => {
        const result = str.slice(1);
        return result;
      };

      const elementName = removeHashCharacter(locHash);
      const element = document.getElementsByName(elementName)[0];

      if (element) {
        const elementTopPos = element.getBoundingClientRect().top;
        const topPos =
          elementTopPos + window.pageYOffset - apiMaticWidgetTopPosition;
          window.scrollTo(element, topPos);
          updateLinkColor(location.hash, true); // add style to new link
      }
    };
     
     useEffect(() =>{        
     if(mounted.current) {
      const timer = setTimeout(() => {  
        if(location.hash?.indexOf("appointmentbooking-created") == -1) {
        const linkElement = document.querySelectorAll("a[href='#/http/mindbody-webhooks-api/events/appointment/appointmentbooking-created']")[1] as HTMLElement;
        const parentElement = linkElement?.parentNode as HTMLElement;
        if(parentElement){       
        parentElement?.classList.remove("diumwi");
        parentElement?.classList.add("hmgKcy");        
        }
        
      if(linkElement){
         const innerSpan = linkElement.getElementsByTagName("span")[0];
             innerSpan?.classList.remove("fTkWmo");
             innerSpan?.classList.add("impzxR");
       }      
      }

      },  2000);
      return () => clearTimeout(timer)      
     }
     }, [mounted.current,location.hash] );

    const updateLinkColor = (locHash: string, isNew: boolean) => {
        // Highlight tocContainer link
        const tocContainer = document.getElementById("toc-container");
        if (tocContainer) {

            const leftLink = tocContainer.querySelectorAll(
                `a[href='${locHash}']`
            )[0] as HTMLElement;
            
            if (leftLink) {
                const parentElement = leftLink.parentElement;
                const insideSpan = leftLink.getElementsByTagName("span")[0];
                if (isNew) {
                    parentElement?.classList.remove("hmgKcy");
                    insideSpan?.classList.remove("impzxR");

                    parentElement?.classList.add("diumwi");  //highlightedDiv
                    insideSpan?.classList.add("fTkWmo"); //highlightedLink

                    
                } else {
                 
                  parentElement?.classList.add("hmgKcy");  //Nomal Div
                  insideSpan?.classList.add("impzxR"); //Normal span

                    parentElement?.classList.remove("diumwi");  
                    insideSpan?.classList.remove("fTkWmo"); 
                }
            }    
      }
    };

    useEffect(() => {
      naviagateToElement(location.hash);

        if (location.hash !== newLocation) {
            updateLinkColor(newLocation, false); // Remove style from old link
        setNewLocation(location.hash);
      }
    }, [apiMaticWidgetTopPosition, location.hash, newLocation, window.pageYOffset]);
       

    useEffect(() => {
        if (window?.location.origin.indexOf('local') > -1) {
            apiMaticObject = { "container": "apimatic-widget", "portalStyle": "default", "apiKey": "xxx", "baseUrl": "./../", "enableExport": false, "enableAnalytics": false, "enableConsoleCalls": true, "useProxyForConsoleCalls": true, "languageSettings": { "http_curl_v1": { "sdkDownloadLink": "", "disableSdkDownload": false }, "cs_net_standard_lib": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-cs_net_standard_lib.zip", "disableSdkDownload": false }, "ruby_generic_lib": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-ruby_generic_lib.zip", "disableSdkDownload": false }, "php_generic_lib_v2": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-php_generic_lib_v2.zip", "disableSdkDownload": false }, "python_generic_lib": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-python_generic_lib.zip", "disableSdkDownload": false } }, "initialPlatform": "http_curl_v1", "themeOverrides": { "palette": { "primaryColor": "#29545E", "linkColor": "#29545E", "colors": { "C000": "#FFFFFF", "C100": "#F9FAFE", "C200": "#F5F7F8", "C300": "#E7E9F2", "C400": "#CED2E2", "C500": "#B0B5C9", "C600": "#858BA5", "C700": "#606E8A", "C800": "#2d2d2d", "C900": "#29545E", "C1000": "#1D2236" } }, "fontSource": ["/assets/fonts/averta/Averta.css"], "cssStyles": { "headings": { "fontFamily": "Averta", "h1": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h2": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h3": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h4": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h5": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h6": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" } }, "body": { "fontFamily": "Averta", "text1": { "fontFamily": "Averta", "fontSize": "15px", "fontWeight": "400", "fontStyle": "normal", "lineHeight": "1.75" }, "text2": { "fontFamily": "Averta", "fontSize": "13.33px", "fontWeight": "400", "fontStyle": "normal", "lineHeight": "1.75" }, "text3": { "fontFamily": "Averta", "fontSize": "11.85px", "fontWeight": "400", "fontStyle": "normal", "lineHeight": "1.75" } } } }, "codegenApiRoutes": { "docsgen": "/devportal/static/docs/mindbody.pushapi.api-{template}.json", "codegen": "/devportal/static/docs/mindbody.pushapi.api-{template}.zip", "transform": "/devportal/static/docs/mindbody.pushapi.api-{format}.{ext}" }, "renameHttpToRest": false }
        }
        else {
            apiMaticObject = { "container": "apimatic-widget", "portalStyle": "default", "apiKey": "xxx", "baseUrl": "", "enableExport": false, "enableAnalytics": false, "enableConsoleCalls": true, "useProxyForConsoleCalls": true, "languageSettings": { "http_curl_v1": { "sdkDownloadLink": "", "disableSdkDownload": false }, "cs_net_standard_lib": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-cs_net_standard_lib.zip", "disableSdkDownload": false }, "ruby_generic_lib": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-ruby_generic_lib.zip", "disableSdkDownload": false }, "php_generic_lib_v2": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-php_generic_lib_v2.zip", "disableSdkDownload": false }, "python_generic_lib": { "sdkDownloadLink": "https://github.com/mindbody/Mindbody-API-SDKs/raw/main/WebhooksAPI/mindbody.pushapi.api-python_generic_lib.zip", "disableSdkDownload": false } }, "initialPlatform": "http_curl_v1", "themeOverrides": { "palette": { "primaryColor": "#29545E", "linkColor": "#29545E", "colors": { "C000": "#FFFFFF", "C100": "#F9FAFE", "C200": "#F5F7F8", "C300": "#E7E9F2", "C400": "#CED2E2", "C500": "#B0B5C9", "C600": "#858BA5", "C700": "#606E8A", "C800": "#2d2d2d", "C900": "#29545E", "C1000": "#1D2236" } }, "fontSource": [`https://static-content.mindbodyonline.com/ui/devportal/${envName}/${version}/assets/fonts/averta/Averta.css`], "cssStyles": { "headings": { "fontFamily": "Averta", "h1": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h2": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h3": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h4": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h5": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" }, "h6": { "fontFamily": "Averta", "fontSize": "27px", "fontWeight": "500", "fontStyle": "normal", "lineHeight": "1.3" } }, "body": { "fontFamily": "Averta", "text1": { "fontFamily": "Averta", "fontSize": "15px", "fontWeight": "400", "fontStyle": "normal", "lineHeight": "1.75" }, "text2": { "fontFamily": "Averta", "fontSize": "13.33px", "fontWeight": "400", "fontStyle": "normal", "lineHeight": "1.75" }, "text3": { "fontFamily": "Averta", "fontSize": "11.85px", "fontWeight": "400", "fontStyle": "normal", "lineHeight": "1.75" } } } }, "codegenApiRoutes": { "docsgen": `https://static-content.mindbodyonline.com/ui/devportal/${envName}/${version}/static/docs/mindbody.pushapi.api-{template}.json`, "codegen": `https://static-content.mindbodyonline.com/ui/devportal/${envName}/${version}/static/sdks/mindbody.pushapi.api-{template}.zip`, "transform": `https://static-content.mindbodyonline.com/ui/devportal/${envName}/${version}/static/exports/mindbody.pushapi.api-{format}.{ext}` }, "renameHttpToRest": false }
        }
        var script = document.createElement("script");
        script.src = "https://dxjs.apimatic.io/v7/static/js/portal.v7.js";
        script.onload = function () {
            /* @ts-ignore */
            APIMaticDevPortal?.show(
                apiMaticObject
            );
        };
        document.getElementsByTagName("head")[0].appendChild(script);
        return () => {
            <div className="hosted-api-docs">
                document.head.removeChild(script);
                    </div>
        };

    }, [])

    let observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            let oldValue = mutation.oldValue;
            let newValue = mutation.target.textContent;          
            let loadingElement = document.getElementsByClassName('sc-bczRLJ sc-jgbSNz ZPbXq');
      
            if (oldValue !== newValue && (loadingElement && loadingElement.length > 0)) {
              setLoading(true);
            }
            else{
              setLoading(false);
            }
        });
    });

    observer.observe(document.body, {
        characterDataOldValue: true,
        subtree: true,
        childList: true,
        characterData: true
    });
    
    const hasApiEndpointsInUrl = () => {      
        return location.hash.indexOf(apiEndpoint) !== -1;       
     }

    return (
        <div id="apimatic-widget" className={"w-full h-screen cs-font " + (hasApiEndpointsInUrl() == true ? '' : 'api-matic-container') + (isLoading == true ? 'loading-screen-height ' : '')}>

        </div>
    );
}

export default WebhooksApi